import React, { useEffect, useState } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  Row,
} from "../../../components/Component";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import { listLMSStudentQuestionAPI } from "../../../api/LMS/master";
import { toast } from "react-toastify";
import useLogout from "../../../utils/Utils";

const StudentQnA = () => {
  const logout= useLogout()
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [columns, setColumns] = useState([
    {
      name: "Session",
      selector: (row) => row?.session,
      sortable: true,
    },
    {
      name: "Class",
      selector: (row) => row?.class,
      sortable: true,
      wrap: true,
    },
    {
      name: "Stream",
      selector: (row) => row?.stream_name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Subject",
      selector: (row) => row?.subject,
      sortable: true,
      wrap: true,
    },

    {
      name: "Learner Id",
      selector: (row) => row?.language,
      sortable: true,
    },
    {
      name: "Learner Name",
      selector: (row) => row?.language,
      sortable: true,
    },
    {
      name: "Question",
      selector: (row) => row?.language,
      sortable: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`}>
            {" "}
            <Icon name="edit" />
          </Button>
        </div>
      ),
    },
  ]);
  useEffect(() => {
    getStudentQuestions();
  }, []);
  const getStudentQuestions = () => {
    setIsLoading(true);
    const data = {};
    listLMSStudentQuestionAPI(data)
      .then((res) => {
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setData(res.data.data);
          setIsLoading(false);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false)
        console.error(err);
      });
  };
  return (
    <>
      <Head title="Student Questions" />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Student Questions"}
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className={"g-gs"}>
            <MyDataTable data={data} columns={columns} isLoading={isLoading} title={"Student Questions"} />
          </Row>
        </Block>
      </Content>
    </>
  );
};

export default StudentQnA;
